module.exports = __webpack_public_path__ + "image_placeholder.ebe9884b2152a08a525f.jpg";


//////////////////
// WEBPACK FOOTER
// /media/krylancelo/OS/Data/Work/krylab/Artetia/beta/src/assets/img/image_placeholder.jpg
// module id = ../../../../../../../../../../../media/krylancelo/OS/Data/Work/krylab/Artetia/beta/src/assets/img/image_placeholder.jpg
// module chunks = styles